(function () {
    function setupSearchSection(section) {
        if (!section) return;

        var body = section.querySelector('[data-scp-search-body]');
        var filterToggleBtn = section.querySelector('[data-scp-filter-toggle]');
        var filterSidebar = section.querySelector('[data-scp-filter-sidebar]');
        var filterOverlay = section.querySelector('[data-scp-filter-overlay]');
        var filterCloseBtn = section.querySelector('[data-scp-filter-close]');
        var sentinel = section.querySelector('[data-scp-infinite-sentinel]');
        var spinner = section.querySelector('[data-scp-infinite-spinner]');
        var productGrid = section.querySelector('[data-scp-product-grid]');
        var mobileBreakpoint = Number(section.dataset.scpMobileBreakpoint || 768);
        var mobileMedia = window.matchMedia('(max-width: ' + mobileBreakpoint + 'px)');
        var observer = null;

        if (!body || !filterSidebar) return;

        function isMobileLayout() {
            return mobileMedia.matches;
        }

        function syncFilterState(isOpen) {
            var isMobile = isMobileLayout();

            if (isMobile) {
                filterSidebar.classList.toggle('is-mobile-open', isOpen);
                filterSidebar.classList.remove('is-collapsed');
                if (filterOverlay) {
                    filterOverlay.hidden = !isOpen;
                    filterOverlay.classList.toggle('is-active', isOpen);
                }
                document.body.style.overflow = isOpen ? 'hidden' : '';
                body.classList.add('is-filter-closed');
            } else {
                filterSidebar.classList.toggle('is-collapsed', !isOpen);
                filterSidebar.classList.remove('is-mobile-open');
                if (filterOverlay) {
                    filterOverlay.classList.remove('is-active');
                    filterOverlay.hidden = true;
                }
                document.body.style.overflow = '';
                body.classList.toggle('is-filter-closed', !isOpen);
            }

            filterSidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
            if (filterToggleBtn) {
                filterToggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
                filterToggleBtn.classList.toggle('is-active', isOpen && !isMobile);
            }
        }

        function toggleFilter() {
            var shouldOpen = isMobileLayout()
                ? !filterSidebar.classList.contains('is-mobile-open')
                : filterSidebar.classList.contains('is-collapsed');
            syncFilterState(shouldOpen);
        }

        function closeFilter() {
            syncFilterState(false);
        }

        function bindFilterAccordions() {
            section.querySelectorAll('[data-scp-filter-group-toggle]').forEach(function (header) {
                if (header.dataset.scpBound === 'true') return;
                header.dataset.scpBound = 'true';

                header.addEventListener('click', function () {
                    var content = header.nextElementSibling;
                    if (!content) return;
                    var willOpen = !header.classList.contains('is-open');
                    header.classList.toggle('is-open', willOpen);
                    header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
                    content.classList.toggle('is-open', willOpen);
                });
            });
        }

        function ensureCardInit() {
            if (typeof window.scpInitVendensSlider === 'function' && section.id) {
                delete section.dataset.vpsInit;
                window.scpInitVendensSlider(section.id);
            } else if (typeof window.initVendensSlider === 'function' && section.id) {
                delete section.dataset.vpsInit;
                window.initVendensSlider(section.id);
            }
        }

        async function loadMore() {
            if (!sentinel || !productGrid || sentinel.dataset.loading === 'true') return;
            var nextUrl = sentinel.getAttribute('data-next-url');
            if (!nextUrl) return;

            sentinel.dataset.loading = 'true';
            if (spinner) spinner.hidden = false;

            try {
                var response = await fetch(nextUrl, { credentials: 'same-origin' });
                var html = await response.text();
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var nextSection = doc.getElementById(section.id);
                if (!nextSection) throw new Error('Next section not found');

                var newItems = nextSection.querySelectorAll('[data-scp-product-grid] .scp-search__product-cell');
                if (newItems.length) {
                    var frag = document.createDocumentFragment();
                    newItems.forEach(function (item) { frag.appendChild(item); });
                    productGrid.appendChild(frag);
                    ensureCardInit();
                }

                var nextSentinel = nextSection.querySelector('[data-scp-infinite-sentinel]');
                if (nextSentinel && nextSentinel.getAttribute('data-next-url')) {
                    sentinel.setAttribute('data-next-url', nextSentinel.getAttribute('data-next-url'));
                } else {
                    if (observer) observer.disconnect();
                    var wrapper = sentinel.closest('.scp-search__load-more-wrap');
                    if (wrapper) wrapper.remove();
                }
            } catch (error) {
                console.error('SCP search load more error:', error);
            } finally {
                sentinel.dataset.loading = 'false';
                if (spinner) spinner.hidden = true;
            }
        }

        if (!section.dataset.scpSearchBound) {
            section.dataset.scpSearchBound = 'true';

            if (filterToggleBtn) filterToggleBtn.addEventListener('click', toggleFilter);
            if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilter);
            if (filterOverlay) filterOverlay.addEventListener('click', closeFilter);
            if (typeof mobileMedia.addEventListener === 'function') {
                mobileMedia.addEventListener('change', function () {
                    syncFilterState(false);
                });
            }

            if (sentinel && !sentinel.dataset.scpObserverBound) {
                sentinel.dataset.scpObserverBound = 'true';
                observer = new IntersectionObserver(function (entries) {
                    entries.forEach(function (entry) {
                        if (entry.isIntersecting) {
                            loadMore();
                        }
                    });
                }, {
                    rootMargin: '0px 0px 280px 0px',
                    threshold: 0
                });
                observer.observe(sentinel);
            }
        }

        bindFilterAccordions();
        ensureCardInit();
        syncFilterState(false);
    }

    function initAll(root) {
        (root || document).querySelectorAll('.scp-search-section').forEach(setupSearchSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
    } else {
        initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('scp:search:updated', function (event) { initAll(event.target || document); });
    document.addEventListener('vendens:search:updated', function (event) { initAll(event.target || document); });
})();
